import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=521b6a3e&"
import script from "./Questions.vue?vue&type=script&lang=ts&"
export * from "./Questions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521b6a3e')) {
      api.createRecord('521b6a3e', component.options)
    } else {
      api.reload('521b6a3e', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=521b6a3e&", function () {
      api.rerender('521b6a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/stay-inputs/Questions.vue"
export default component.exports